import React from "react"

import makeSecureImageUrl from "utils/makeSecureImageUrl"

import ImagePreload from "components/image-preload"
import {
  Wrapper,
  HeaderImage,
  Overlay,
  Title,
  Sponsor,
  SponsoredBy,
  SponsorImageWrapper,
  SponsorImagePlaceholder,
} from "./styles"

const PremiumHeader = ({ article, element, background, isTranslucent }) => {
  const { image } = element

  const headerSizes = {
    1024: [1440, 99999],
    768: [1023, 99999],
    0: [480, 315],
  }

  const { premiumPartnerLogo: logoPath } = article
  const logoTransform = "c_fit,w_230,h_30,q_auto,f_auto,fl_lossy"

  return (
    <Wrapper isTranslucent={isTranslucent}>
      {image && (
        <HeaderImage
          fetchpriority="high"
          imageData={image}
          sizes={[
            {
              query: 1024,
              width: headerSizes[1024][0],
              height: headerSizes[1024][1],
              transforms: `c_fill,g_auto,w_${headerSizes[1024][0]},q_auto,f_auto,fl_lossy`,
            },
            {
              query: 768,
              width: headerSizes[768][0],
              height: headerSizes[768][1],
              transforms: `c_fill,g_auto,w_${headerSizes[768][0]},q_auto,f_auto,fl_lossy`,
            },
            {
              width: headerSizes[0][0],
              height: headerSizes[0][1],
              transforms: `c_fill,g_auto,w_${headerSizes[0][0]},h_${headerSizes[0][1]},q_auto,f_auto,fl_lossy`,
            },
          ]}
          alt={image.altText}
          isTranslucent={isTranslucent}
        />
      )}
      <Overlay isTranslucent={isTranslucent} />
      <Title background={background}>
        These Are The Best Hydrating Moisturizers For Your Skin Type
      </Title>
      <Sponsor background={background}>
        <SponsoredBy>SPONSORED BY</SponsoredBy>
        {logoPath ? (
          <SponsorImageWrapper>
            <ImagePreload
              baseUrl={logoPath}
              images={[
                {
                  width: 230,
                  height: 30,
                  transforms: logoTransform,
                },
              ]}
            />
            <img src={makeSecureImageUrl(logoPath, logoTransform)} alt="" fetchpriority="high" />
          </SponsorImageWrapper>
        ) : (
          <SponsorImagePlaceholder />
        )}
      </Sponsor>
    </Wrapper>
  )
}

export default React.memo(PremiumHeader)
